import { Tag, TagCloseButton, TagLabel, TagProps } from '@chakra-ui/react'
import React from 'react'

import { IconByName, IconNames } from '~shared-components/icons/brand'

type Alignment = 'left' | 'right'
export interface PillProps extends TagProps {
  icon?: IconNames
  iconAlign?: Alignment
  isDisabled?: boolean
  onClick?: () => void
}

const clickStub = (event: React.MouseEvent) => event.preventDefault()
export const Pill: React.FC<PillProps> = ({
  children,
  colorScheme = 'neutral',
  icon,
  iconAlign = 'right',
  onClick,
  ...props
}) => {
  return (
    <Tag
      alignItems="center"
      as="div"
      colorScheme={colorScheme}
      flexDirection={iconAlign === 'right' ? 'row' : 'row-reverse'}
      justifyContent={onClick ? 'space-between' : 'center'}
      onClick={onClick ? clickStub : undefined}
      {...props}
    >
      <TagLabel>{children}</TagLabel>
      {onClick ? (
        icon ? (
          <IconByName
            boxSize="20px"
            color="currentColor"
            cursor={props.isDisabled ? 'default' : 'pointer'}
            data-testid="pill-icon"
            name={icon}
            onClick={onClick}
          />
        ) : (
          <TagCloseButton
            data-testid="pill-icon"
            isDisabled={props.isDisabled}
            onClick={onClick}
          />
        )
      ) : null}
    </Tag>
  )
}
